import { ActionContext } from "vuex";
// import TYPES from './types'
import TYPES from "./types";
import { RootState } from "./index";
import request from "~~/utils/request";
import { config as api } from "~~/const/apis";
import {
  ILeadFormResult,
  ICommonResult,
  initLeadFormResult,
  IShopifyBlack
} from "~/types/config";

interface State {
  leadFormConfig: ILeadFormResult;
}

export const state = (): State => ({
  leadFormConfig: initLeadFormResult
});

export const mutations = {
  [TYPES.SET_LEAD_FORM_CONFIG](state: State, leadFormConfig: ILeadFormResult) {
    state.leadFormConfig = leadFormConfig;
  }
};

export const actions = {
  async getLeadFormConfig(
    { state, commit }: ActionContext<State, RootState>,
    vm: any
  ) {
    try {
      const { code, data, msg } = await request.get(api.lead_form_config);
      if (code === 0) {
        commit(TYPES.SET_LEAD_FORM_CONFIG, data);
      } else {
        vm.$message.error(msg);
      }
    } catch (error) {
      console.log(error);
    }
  },
  getCommonConfig({
    commit
  }: ActionContext<State, RootState>): Promise<ICommonResult> {
    return request.get(api.common_config);
  },
  getShopifyBlack({
    commit
  }: ActionContext<State, RootState>): Promise<IShopifyBlack> {
    return request.get(api.shopify_black);
  }
};
